import React from 'react';
import {
  LiveClassSessionsDashboardCardProps,
  Session
} from '@magoosh/organisms/live_class_sessions_dashboard_card/types';
import CheckpointCard from '@magoosh/gre/organisms/checkpoint_card';
import moment from 'moment-timezone';
import style from './style.module.scss';
import { paths } from 'config/path_helpers';
import { formatTimeRange } from 'utilities/time';
import PersonWithSpeechBubble from './person_with_speech_bubble.svg';
const timeZone = moment.tz.guess();

const LiveClassSessionsDashboardCard: React.FC<LiveClassSessionsDashboardCardProps> = (props) => {

  const headline = () => {
    if (props.onDemand) {
      return 'Watch your classes at your own pace and schedule.'
    }

    if (props.upcomingSessions.length <= 0)
    {
      return 'You made it through all your classes!';
    }

    if (props.firstSessionPending) {
      return `Your classes start on ${moment(props.upcomingSessions[0].startTime).format('MMMM D')}!`;
    }

    return 'You have classes coming up soon.';
  };

  const subheadline = () => {
    if (props.onDemand) { return null; }

    if (props.upcomingSessions.length <= 0) {
      return <p><a href={paths.liveClasses()}>Revisit recordings of past classes</a>.</p>
    }

    if (props.instructor) {
      return <p>Your live class instructor is {props.instructor}!</p>;
    }

    return null;
  }

  let commonTimeMessage = null;

  return <CheckpointCard>
    <div className={style.sessionsCard}>
      <div>
        <div>
          <img alt="PersonWithSpeechBubble" src={PersonWithSpeechBubble} />
        </div>
        <div className={style.title}>Classes</div>
        <div>
          <p>
            <small>
              <a href={paths.liveClasses()} className={'text-no-decoration'}>See all Classes</a>
            </small>
          </p>
        </div>
      </div>
      <div>
        <p className={style.headline}>{headline()}</p>
        {subheadline()}
        <div>
          {props.upcomingSessions.map((session: Session) => {
            let formattedTimeRange = '';

            if (session.startTime) {
              const startTime = moment(session.startTime).tz(timeZone);
              const endTime = moment(session.endTime).tz(timeZone);

              formattedTimeRange = `, ${formatTimeRange(startTime, endTime, 'MMMM Do, ')}`
            }

            return <div key={session.name}>
              <a href={paths.liveClasses()}>{session.name}</a>{formattedTimeRange}
            </div>
          })}
          {props.onDemand && props.sessionsCount > props.upcomingSessions.length && <div>
            + {props.sessionsCount - props.upcomingSessions.length} more
          </div>}
        </div>
      </div>
    </div>
  </CheckpointCard>
}

export default LiveClassSessionsDashboardCard;
